import type { PropsWithChildren } from 'react';

export type BadgeTone = 'positive' | 'negative' | 'warning' | 'info' | 'neutral';

export function Badge({ tone = 'neutral', children }: PropsWithChildren<{ tone?: BadgeTone }>): React.JSX.Element {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}
